import { FormFields } from 'app/modules/filingFormGenerator/models';
import {
  selectField,
  textField,
  textareaField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

export const getAddressFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  selectField(
    {
      name: 'address.address_type',
      label: 'Address type',
      required: true,
      refTable: 'contact_type',
    },
    referenceTables,
  ),
  textField({ name: 'address.address', label: 'Address', required: true }),
  selectField(
    {
      name: 'address.country_code',
      label: 'Country',
      refTable: 'country_code',
    },
    referenceTables,
  ),
  textField({ name: 'address.state', label: 'State' }),
  textField({ name: 'address.town', label: 'Town' }),
  textField({ name: 'address.city', label: 'City', required: true }),
  textField({ name: 'address.zip', label: 'ZIP code' }),
  textareaField({ name: 'address.comments', label: 'Comments' }),
];
